import React from 'react';
import { Controller } from 'react-hook-form';
import Styles from './FormLanding.css';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { useFormLanding } from '../../model/form-landing';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import TextField from '../../widgets/TextField/TextField';
import { getFieldError } from '../../shared/utils/form';
import Button from '../../widgets/Button/Button';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import LoadingModal from '../../../../components/organisms/LoadingModal';
import { useLockPageScroll } from '../../../../utils/useLayout';

function FormLanding() {
  const state = useSimuladorEnergiaSolarState();
  const formLanding = useFormLanding();

  useLockPageScroll(formLanding.loading || state.modalTermsOpen);

  return (
    <>
      <section id="form-energia-solar" className="form-simulacao">
        <ContainerHome24>
          <div className="stack">
            <div className="form-container">
              <h2 className="title">Simule seu financiamento de placa solar</h2>
              <p className="subtitle top-spacing">
                Informe os dados abaixo.
                <br /> Em poucas etapas você envia sua simulação. <b>Sem compromisso!</b>
              </p>

              <form className="form-render top-spacing" onSubmit={formLanding.handleSubmit}>
                {formLanding.fields.map((field) => {
                  return (
                    <Controller
                      key={`field-${field.name}`}
                      name={field.name}
                      control={formLanding.form.control}
                      render={(renderOptions) => {
                        return (
                          <TextField
                            {...renderOptions.field}
                            {...getFieldError({
                              isTouched: renderOptions.fieldState.isTouched,
                              error: renderOptions.fieldState.error?.message,
                              isSubmitted:
                                renderOptions.formState.submitCount > 0 ||
                                renderOptions.formState.isSubmitted,
                            })}
                            {...field}
                          />
                        );
                      }}
                    />
                  );
                })}

                <p className="text-terms">
                  Ao clicar em ”continuar” você está de acordo com os&nbsp;
                  <a
                    id="text-show-modal-terms"
                    onClick={(ev) => {
                      ev.preventDefault();
                      ev.stopPropagation();

                      state.setModalTermsOpen(true);
                    }}
                  >
                    Termos e condições de uso e com a política de privacidade.
                  </a>
                </p>

                <Button
                  type="submit"
                  maxWidth={272}
                  disabled={formLanding.loading}
                  loading={formLanding.loading}
                  className="submit-form-solar"
                >
                  Continuar
                </Button>
              </form>
              <p className="disclaimer">
                A simulação é gratuita e não garante a aprovação do financiamento. A contratação
                está sujeita à análise de crédito e às condições do produto.
              </p>
            </div>

            <div className="img-panel">
              <img
                src="assets/simulador-energia-solar/landing/light-panel.svg"
                alt="ilustração painel solar"
              />
            </div>
          </div>
        </ContainerHome24>

        <ErrorMessage />
        {formLanding.loading && <LoadingModal />}
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default FormLanding;
